import {Component, Input, OnInit} from '@angular/core';
import {DataService, OperationsService, StorageService} from '../../_services';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MyDatePickerModule } from 'mydatepicker';
import { IMyDpOptions } from 'mydatepicker';
import {
  IMyDateModel,
  IMyInputFieldChanged,
  IMyCalendarViewChanged,
  IMyInputFocusBlur,
  IMyMarkedDate,
  IMyDate,
  IMySelector
} from 'mydatepicker';
import {ToastrService} from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-alljournals',
  templateUrl: './alljournals.component.html',
  styleUrls: ['./alljournals.component.css']
})
export class AlljournalsComponent implements OnInit {
  currentUser: any;
  journals: any[];
  bulk_approve: boolean = false;
  check_all: boolean = false;
  is_loading: boolean = false;
  loading: boolean = false;
  preloading = false;
  status: any;
  issearching = false;
  isfiltering = false;
  selected_ids: any;
  searchForm: FormGroup;
  searchForm_: FormGroup;
  source: any;
  start_date: any;
  end_date: any;
  journal_no: any;
  page_number: any;
  journal_narration='';
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    height: '34px',
    width: '210px',
    dateFormat: 'yyyy-mm-dd',
    openSelectorTopOfInput: false
  };
  journals_length: number;
  end: any;
  start: any;
  new_journal_overlay: boolean;
  showOpen = false;
  active_loans:any;
  loan_id:any;
  next = 0
  prev = 0
  newAccountForm: FormGroup;
  constructor(
    public router: Router,
    private operationsService: OperationsService,
    private storageService: StorageService,
    private toastr: ToastrService,
    private dataService: DataService
  ) {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.dataService.closeOverlayModal.subscribe(res =>  {
      this.new_journal_overlay = res;
      this.getAllJournals();
    });
    this.newAccountForm = new FormGroup({
      PREV: new FormControl(0),
      NEXT: new FormControl(0),
      BATCH_ID: new FormControl(),
      START_DATE: new FormControl(),
      END_DATE: new FormControl(),
      SOURCE: new FormControl(),
      IS_APPROVED: new FormControl(),
      NARRATION: new FormControl(),
    })
  }

  ngOnInit() {
    this.getAllJournals();
  }
  showSuccess(message) {
    this.toastr.success(message, 'Success');
  }
  showError(message) {
    this.toastr.error(message, 'Error');
  }
  createNewJournal() {
    // this.new_journal_overlay = !this.new_journal_overlay;
    this.router.navigate(['/accounting/new_account_journal']);
  }
  getAllJournals() {
    return this.operationsService
      .getAllNewJournals(this.currentUser.token,this.newAccountForm.value)
      .subscribe(res => {
        this.newAccountForm.patchValue({
          NEXT: res.data.next,
          PREV: res.data.prev
        }); 
        this.journals_length = res.data.count
        this.journals = res.data.journals
        // if (res.status) {
          
          
        // }
      });
  }
  searchJournal() {
    this.newAccountForm.patchValue({
      NEXT: 0,
      PREV: 0
    }); 
    return this.operationsService
      .getAllNewJournals(this.currentUser.token, this.newAccountForm.value)
      .subscribe(res => {
        this.newAccountForm.patchValue({
          NEXT: res.data.next,
          PREV: res.data.prev
        }); 
        this.journals_length = res.data.count
        this.journals = res.data.journals
        if (res.status) {
          
          
        }
      });
  }
  nextJournals() {
    return this.operationsService.nextJournals(this.currentUser.token, true, this.page_number).subscribe(res => {
      if (res.status) {
        this.journals = res.all_journals_list;
        this.journals_length = res.count;
        this.end = res.end;
        this.start = res.start;
        this.page_number = res.pagenumber;
      }
    }, () => {
      this.showError('An error occured, try again');
    });
  }
  prevJournals() {
    return this.operationsService.nextJournals(this.currentUser.token, false, this.page_number).subscribe(res => {
      if (res.status) {
        this.journals = res.all_journals_list;
        this.journals_length = res.count;
        this.end = res.end;
        this.start = res.start;
        this.page_number = res.pagenumber;
      }
    }, () => {
      this.showError('An error occured, try again');
    });
  }
  bulkApprove() {
    this.bulk_approve = !this.bulk_approve;
  }
 checkAll() {
    this.check_all = !this.check_all;
 }
  approveAll() {
    this.is_loading = true;
   return this.operationsService.bulkApprove(this.journals, this.currentUser.token, this.check_all).subscribe(res => {
     console.log(res);
     if (res.status) {
       this.showSuccess(res.response);
       this.is_loading = false;
       this.getAllJournals();
     } else {
       this.showError(res.response);
       this.is_loading = false;
     }
   }, err => {
     this.is_loading = false;
   });
  }
  // searchJournal() {
  //   // if (!this.start_date) {
  //   //   return this.showError('Start date cannot be empty');
  //   // }
  //   // if (!this.end_date) {
  //   //   return this.showError('End date cannot be empty');
  //   // }
  //   // if (!this.journal_no) {
  //   //   return this.showError('Journal number cannot be empty');
  //   // }
  //   // if (!this.status) {
  //   //   return this.showError('Select a status');
  //   // }
  //   // if (!this.source) {
  //   //   return this.showError('Select a source');
  //   // }
  //   this.loading = true;
  //   this.operationsService.searchForJournal(this.currentUser.token, this.start_date, this.end_date, this.status, this.journal_no, this.source, this.journal_narration, this.loan_id).subscribe(res => {
  //     this.journals = res.all_journals_list;
  //     this.journals_length = res.count;
  //     this.end = res.end;
  //     this.loading = false;
  //     this.start_date = '';
  //     this.end_date = '';
  //     this.status = '';
  //     this.journal_no = '';
  //     this.source = '';
  //     this.journal_narration = '';
  //   }, err => {
  //     this.loading = false;
  //   });
  // }
  // showOpenBtn(index) {
  //   if (index) {
  //     this.showOpen = true;
  //   }
  // }
  // hideOpenBtn() {
  //   this.showOpen = false;
  // }
  updateT(acc){
    this.operationsService
      .updateJournalEntry(this.currentUser.token, acc)
      .subscribe(res => { 
      }, () => { 
      });
  }
  gotoNewAccount(){
    this.router.navigate(['/accounting/new_account_journal']);
  }
}
